import { render, staticRenderFns } from "./launch-header.vue?vue&type=template&id=3141153a&"
import script from "./launch-header.vue?vue&type=script&lang=ts&"
export * from "./launch-header.vue?vue&type=script&lang=ts&"
import style0 from "./launch-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports